import { Button } from '@design/components/button/Button';
import clsx from 'clsx';
import { ReactNode, useState } from 'react';

import styles from './FiltersPanel.module.scss';

interface FiltersPanelProps {
  title: ReactNode;
  children: ReactNode;
}

export const FiltersPanel = ({
  title,
  children,
  ...rest
}: FiltersPanelProps) => {
  const [expanded, setExpanded] = useState(true);

  const toggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={styles.container} {...rest}>
      <div className={styles.titleContainer}>
        <p className={styles.title}>{title}</p>
        <Button
          className={styles.styledButton}
          iconName={expanded ? 'ChevronLightUp' : 'ChevronLightDown'}
          variant="empty"
          size="xsmall"
          data-testid="expand-button"
          onClick={toggle}
        />
      </div>
      <div
        className={clsx(styles.filtersContainer, {
          [styles.expanded]: expanded,
        })}
      >
        {children}
      </div>
    </div>
  );
};
